export default __webpack_public_path__ + "static/media/daggamalt.2c168f26.jpg";